import jobRolesAnalyticsCollection from 'modules/job_catalog/store/collections/rolesAnalytics'

export const SORTABLE_ATTRIBUTES = ['average_age', 'tenure'] as const
type SortableAttribute = (typeof SORTABLE_ATTRIBUTES)[number]

export const sort = (roleId: number, attribute: SortableAttribute) => {
  const analytics = jobRolesAnalyticsCollection.find({ id: roleId })
  const value = analytics?.attributes[attribute]
  return value?.error ? 0 : value?.results?.[0]?.value
}
